import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { cBookingsummary } from 'src/types/bookingsummary';
import { GlobalService } from '../_services/global.service';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.css']
})
export class SummaryComponent implements OnInit {
  @Input() BookingSummary: cBookingsummary;
  ParseBS: cBookingsummary;
  CurrencySymbol: string = localStorage.getItem("Currency") == null ? "GBP" : localStorage.getItem("Currency")!;

  constructor(private router: Router, private globalService: GlobalService
    
  ) {
    this.ParseBS = {
      bookingId: "",
      bookingIdHR: "",
      Disabled: false,
      admissions: "",
      startTime: new Date(),
      endTime: new Date(),
      name: "",
      arrival: new Date(),
      guests: 0,
      total: 0,
      outstanding: 0,
      paid: 0,
      totaldiscounts: 0,
      totalbookingfees: 0,
      bookingfee: 0,
      customerName: "",
      customerAddress: "",
      customerMobile: "",
      customerEmail: "",
      packageName: "",
      publicBooking: false,
      extras: "",
      upgrade: "",
      upgradetext: "",
      addontext: "",
      itinerary: "",
      notes: "",
      totalbookingfee: 0
    }
   }

  ngOnInit(): void {

    this.globalService.setSmallScreenMenu(false);
    
    this.ParseBS = this.BookingSummary
  }

  editbookingadmissions(BookingID)
  {
    this.router.navigate(
      ['/editbooking/' + BookingID],
      { queryParams: { jumpto: 'admissions' } }
    );
  }

  editbookingpayoff(BookingID)
  {
    this.router.navigate(
      ['/editbooking/' + BookingID],
      { queryParams: { jumpto: 'payment' } }
    );
  }

  editData(ID)
  {
    this.router.navigateByUrl("/editbooking/" + ID);
  }

}
